import { Pipe, PipeTransform } from '@angular/core';
import {TariffSize} from "../../../../../tariff";

@Pipe({
  name: 'indexToTariffEntry',
  standalone: true
})
export class IndexToTariffEntryPipe implements PipeTransform {

  transform(index: 0 | 1 | 2 | number | TariffSize, basic?: string, comfort?: string, premium?: string): string | undefined {
    switch (index) {
      case 1:
      case 'comfort':
        return comfort;
      case 2:
      case 'premium':
        return premium;
      default:
        return basic;
    }
  }

}
